import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_8997_127050)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.758342 9.99976C0.758342 4.89572 4.89596 0.758098 10 0.758098C15.104 0.758098 19.2417 4.89572 19.2417 9.99976C19.2417 15.1038 15.104 19.2414 10 19.2414C4.89596 19.2414 0.758342 15.1038 0.758342 9.99976ZM10 -0.000244141C4.47714 -0.000244141 0 4.4769 0 9.99976C0 15.5226 4.47714 19.9998 10 19.9998C15.5229 19.9998 20 15.5226 20 9.99976C20 4.4769 15.5229 -0.000244141 10 -0.000244141ZM10.875 15.8134H8.53427H8.52921V9.97412H7.31081V7.98727H8.52921V6.42003C8.52921 4.9539 9.31283 4.18545 11.057 4.18545H12.6799V6.22286H11.4109C10.961 6.22286 10.87 6.40486 10.87 6.86998V7.98727H12.6799L12.508 9.94884H10.875V15.8134Z",
			fill: "#565CDE"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8997_127050",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgFb;
